import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material';
import { Inject, Component } from '@angular/core';
import { TranslationService } from '../../common/services/languages/translation.service';
import { MatIcon } from '@angular/material/icon';
import { MatSuffix } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.scss'],
    imports: [MatIcon, MatSuffix, TranslatePipe]
})
export class ConfirmationComponent {
  /**
  * @var CONFIRMATION_MESSAGES to store the messages for each type of confirmation
  **/
  static CONFIRMATION_MESSAGES = {
    'name-update': 'label.name-update',
    'email-update': 'label.email-update',
    'phone-update': 'label.phone-update',
    'address-update': 'label.address-update',
    'customer-update': 'label.customer-update',
    'unable-to-update': 'label.unable-to-update',
    'registration-update': 'label.registration-update',
    'registration-update-not': 'label.registration-update',
    'add-goodwill-update': 'label.add-goodwill-update',
    'add-goodwill-not': 'label.add-goodwill-update'
  };
  /**
  * @var message to store the message for the corresponding type
  **/
  message: string;
  /**
  * @var isSuccess to store the isSuccess for the corresponding type
  **/
  public isSuccess: string;
  constructor(
    private snackBarRef: MatSnackBarRef<ConfirmationComponent>,
    public translate: TranslationService,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
  ) {
    this.isSuccess = data.success;
    this.message = !!ConfirmationComponent.CONFIRMATION_MESSAGES[data.type] ?
      `admin-confirmation.${ConfirmationComponent.CONFIRMATION_MESSAGES[data.type]}${this.isSuccess ? '' : '-not'}` : '';
  }

  /**
  * @method close close the confirmation dialog
  **/
  close(): void {
    this.snackBarRef.dismissWithAction();
  }
}
